import { isNumber } from 'lodash';

export default function unixToDhm(time) {
  const cd = 24 * 60 * 60 * 1000;
  const ch = 60 * 60 * 1000;
  const pad = (n) => (n < 10 && n > 0 ? '0' + n : n);

  if (!isNumber(time)) {
    throw new Error(
      'Expected parameter `time` to be `numeric`, but type `' +
        typeof time +
        '` was supplied in `unixToDHM`.',
    );
  }

  let days = Math.floor(time / cd);
  let hours = Math.floor((time - days * cd) / ch);
  let minutes = Math.floor((time - days * cd - hours * ch) / 60000);
  let seconds = Math.floor((time / 1000) % 60);

  return {
    days: days + '',
    hours: pad(hours) + '',
    minutes: pad(minutes) + '',
    seconds: pad(seconds) + '',
  };
}
